import React from 'react'
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useDispatch, useSelector } from 'react-redux';
import { selectActiveParty, selectParty } from '../../Redux/slices/partyState';

export default function PartyCard({name,firm,docid,setEditParty,setSelectDelete=()=>{}}) {
  const activeParty = useSelector(selectActiveParty)
  const dispatch = useDispatch()
  //console.log({docid,activeParty})
  return (
    <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
        <div className={`h-full ${activeParty===name&&'bg-sky-400'} flex items-center border-gray-200 border p-4 rounded-lg shadow-md `}>
          <div className="w-16 h-16 bg-gray-100 rounded-full mr-4 flex items-center justify-center"><PermIdentityIcon fontSize='large'/></div>
          <div className="flex-grow">
          <h2 onClick={()=>dispatch(selectParty(name))}  className={`${activeParty===name?'text-white':'text-gray-900'} title-font font-medium hover:text-gray-500 cursor-pointer`}>{name}</h2>
            <p className={`${activeParty===docid?'text-gray-100':'text-gray-500'}`}>{firm}</p>
          </div>
          <div className="flex">
          <div onClick={setEditParty} className="w-10 h-10 hover:bg-blue-200 rounded-md mr-4 flex items-center justify-center cursor-pointer"><EditIcon fontSize='medium'/></div>
          <div onClick={()=>setSelectDelete(docid)}className="w-10 h-10 hover:bg-red-200 rounded-md mr-4 flex items-center justify-center cursor-pointer"><DeleteIcon fontSize='medium'/></div>
          </div>
        </div>
      </div>
  )
}
